import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" * Selecione um site e preencha os dados de conexão do banco de dados de origem")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" * Confira se o ID da entidade (Banco de dados de origem) está correto antes de fazer a migração ")
const _hoisted_5 = {
  key: 0,
  class: "w-full flex flex-wrap"
}
const _hoisted_6 = { class: "w-4/12 pr-2" }
const _hoisted_7 = { class: "w-2/12 pr-2" }
const _hoisted_8 = { class: "w-2/12 pr-2" }
const _hoisted_9 = { class: "w-2/12 pr-2" }
const _hoisted_10 = { class: "w-1/12 pr-2" }
const _hoisted_11 = { class: "w-1/12" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Conectar ")
const _hoisted_13 = {
  key: 1,
  class: "w-full grid place-content-center text-center min-h-screen"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Aguarde, isso pode demorar um pouco")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Não saia dessa página ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_SearchOutline = _resolveComponent("SearchOutline")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_alert, {
      title: "Aviso",
      type: "info",
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_n_select, {
              value: _ctx.formRef.id_site,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formRef.id_site) = $event)),
              options: _ctx.sitesOptions,
              placeholder: "Site",
              class: "w-full",
              filterable: ""
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_n_input, {
              value: _ctx.formRef.host,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formRef.host) = $event)),
              placeholder: "Host/Servidor"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_n_input, {
              value: _ctx.formRef.user,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formRef.user) = $event)),
              placeholder: "Usuário"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_n_input, {
              value: _ctx.formRef.pass,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formRef.pass) = $event)),
              placeholder: "Senha"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_n_input, {
              value: _ctx.formRef.id,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formRef.id) = $event)),
              placeholder: "ID Entidade"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_n_button, {
              type: "info",
              class: "w-full",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.migrateData()))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SearchOutline)
              ]),
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_n_spin, { size: "large" }),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]))
      : _createCommentVNode("", true)
  ]))
}